import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeStringEnum } from '../../utils/typeboxHelpers';
import { assetTableSchema } from '../asset/assetTableSchema';

const optionalScoreSchema = Type.Optional(makeStringEnum(['OK', 'A', 'B', 'C', 'D', 'E', 'F', 'NVT']));

export const nen3140Paths = {
    '/api/surveys/{surveyId}/elements/nen3140/objectTree': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'nen3140Controllers.getElements',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    units: Type.Array(
                                        Type.Object({
                                            icons: Type.Array(
                                                Type.Object({
                                                    iconName: Type.String(),
                                                    color: Type.String(),
                                                }),
                                            ),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    icons: Type.Array(
                                                        Type.Object({
                                                            iconName: Type.String(),
                                                            color: Type.String(),
                                                        }),
                                                    ),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.String(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.String(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    icons: Type.Array(
                                        Type.Object({
                                            iconName: Type.String(),
                                            color: Type.String(),
                                        }),
                                    ),
                                    id: Type.String(),
                                    inspectionStandardData: Type.String(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/nen3140': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('unitId')],
        get: {
            operationId: 'nen3140Controllers.getUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                nen3140Score: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'nen3140Controllers.updateUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                nen3140Score: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            nen3140Score: optionalScoreSchema,
                            remarks: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/manifestations/{manifestationId}/inspectionStandardData/nen3140': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('manifestationId')],
        get: {
            operationId: 'nen3140Controllers.getManifestation',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                nen3140Score: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'nen3140Controllers.updateManifestation',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                nen3140Score: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            nen3140Score: optionalScoreSchema,
                            remarks: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/elements/nen3140/report': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'nen3140Controllers.getReportData',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    units: Type.Array(
                                        Type.Object({
                                            assets: Type.Array(
                                                Type.Pick(assetTableSchema, [
                                                    'description',
                                                    'id',
                                                    'type',
                                                    'unitId',
                                                    'filenameThumbnail',
                                                    'filenameMidSize',
                                                    'name',
                                                ]),
                                            ),
                                            surveyInspectionStandardData: Type.Object({
                                                nen3140Score: optionalScoreSchema,
                                                remarks: Type.Optional(Type.String()),
                                            }),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    assets: Type.Array(
                                                        Type.Pick(assetTableSchema, [
                                                            'description',
                                                            'id',
                                                            'type',
                                                            'manifestationId',
                                                            'filenameThumbnail',
                                                            'filenameMidSize',
                                                            'name',
                                                        ]),
                                                    ),
                                                    surveyInspectionStandardData: Type.Object({
                                                        nen3140Score: optionalScoreSchema,
                                                        remarks: Type.Optional(Type.String()),
                                                    }),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.String(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.String(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    nen3140Score: optionalScoreSchema,
                                    id: Type.String(),
                                    inspectionStandardData: Type.String(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
} as const;
